import { FaTruck } from 'react-icons/fa';

export default function TopBar() {
  return <div className="top-bar"><div className="header-container top-bar__inner">
    <span className="top-bar__message"><FaTruck aria-hidden="true" />Free U.S. Shipping on Orders $50+</span>
    <span className="top-bar__message top-bar__center">Healthy Pets, Happier Lives</span>
    <span className="top-bar__message top-bar__right">100% Satisfaction Guarantee</span>
  </div></div>;
}
